<template>
    <div class="relative h-full flex max-mob:justify-around justify-between">
        <template
            v-for="(item, index) in items"
            :key="item.id"
        >
            <div
                v-if="index && showDividers"
                class="mx-3 h-auto grow pt-3"
            >
                <div class="h-px bg-gray-100 dark:bg-gray-750 rounded-full"></div>
            </div>

            <div class="w-fit flex items-center max-mob:flex-col text-xs max-mob:text-xxxs">
                <div
                    class="size-6 min-mob:mr-2 max-mob:mb-2.5 flex items-center justify-center max-mob:font-medium rounded-full"
                    :class="getColorBackground(item)"
                >
                    {{ item.id }}
                </div>

                <div :class="isActive(item) ? 'text-purple dark:text-white font-medium' : 'text-gray-370 dark:text-gray-200'">
                    {{ item.title }}
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
const props = defineProps({
    items: {
        type: Array,
        default: () => [],
    },
    currentStep: {
        type: Number,
        default: 1,
    },
    showDividers: {
        type: Boolean,
        default: false,
    },
})

function getColorBackground({ id }) {
    if (isActive({ id })) {
        return 'bg-purple text-white'
    }

    return 'bg-gray-80 dark:bg-gray-780 text-gray-370 dark:text-gray-200'
}

function isActive({ id }) {
    return props.currentStep === id
}
</script>
